import { loadLovBatch } from '@zoryn/hooks'
import { applySpecialColumnWidths, buildColumnInfo, collectLovTypes } from './column/meta'
import { applyHeaderMinWidths } from './column/resolve-header-min-width'
import {
  applyContentAutoWidths,
  applyFitContainerWidths,
  isAutoColumnWidthEnabled,
} from './column/resolve-column-auto-width'
import { isFilterableColumn } from './filter/filter-utils'
import { captureColumnBaseline } from './methods/custom'
import { resolveGridContainerWidth } from './utils/resolve-layout-width'
import { normalizeGridColumnProps } from './column/seq-column'
import type { DataGrid, GridColumnProps, GridColumnInfo } from './types'
import type { LovConfigContext } from '@zoryn/hooks'

function applyAutoColumnWidths($grid: DataGrid, list: GridColumnInfo[]) {
  if (!isAutoColumnWidthEnabled($grid.options)) {
    return
  }
  const rows = $grid.reactData.tableData as Record<string, unknown>[]
  if (rows.length) {
    applyContentAutoWidths(list, rows, $grid.options)
  }
  const containerWidth = resolveGridContainerWidth($grid)
  if (containerWidth > 0) {
    applyFitContainerWidths(list, containerWidth, $grid.options)
  }
}

export function createLoadColumns(
  $grid: DataGrid,
  getLovConfig: () => LovConfigContext | undefined
) {
  return async (columns: GridColumnProps[]) => {
    const normalized = normalizeGridColumnProps(columns)
    const list: GridColumnInfo[] = []
    normalized.forEach((col, index) => {
      const info = buildColumnInfo(col, index)
      if (info) list.push(info)
    })
    const size = $grid.gridSize?.value
    applySpecialColumnWidths(list, size)
    applyHeaderMinWidths(list, $grid.options, $grid.props, size)
    applyAutoColumnWidths($grid, list)
    $grid.internalData.allColumns = list
    $grid.internalData.visibleColumns = list.filter((col) => col.visible !== false)
    $grid.internalData.titleList = $grid.internalData.visibleColumns.filter(isFilterableColumn)
    captureColumnBaseline($grid)

    const lovTypes = collectLovTypes(normalized)
    if (lovTypes.length) {
      const lovConfig = getLovConfig()
      await loadLovBatch(lovTypes, {
        fetchBatch: lovConfig?.fetchLovBatch,
        fetchLov: lovConfig?.fetchLov,
        cacheTtl: lovConfig?.cacheTtl,
      })
    }
    $grid.updateFooter?.()
  }
}
